import React, { useState } from 'react';
import { Colors } from '../../theme';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import CancelIcon from '@mui/icons-material/Cancel';
import { validateEmail } from 'shared';
import '@fontsource/work-sans';
import '@fontsource/pt-serif';

interface IInputProps {
    id?: string;
    label?: string;
    onChange: (value: string, isValid: boolean) => void;
    value: string;
    error?: boolean;
    errorText?: string;
    maxLength?: number;
    autoComplete?: string;
    disabled?: boolean;
    boldLabel?: boolean;
    type?: string;
    alwaysShowLabel?: boolean;
}

const styles = {
    label: {
        fontFamily: 'Outfit',
        color: Colors.primary,
        lineHeight: '1.2em',
        minHeight: '1.2em',
        display: 'block',
    },
    errorText: {
        fontFamily: 'Outfit',
        color: Colors.error,
        fontSize: 12,
        margin: 0,
    },
};

const StyledInput = styled('input')({
    '&:hover': {
        outline: 'none',
    },
    '&:focus': {
        outline: 'none',
    },
    '&::placeholder': {
        color: Colors.textSecondary,
    },
    '&:disabled': {
        backgroundColor: Colors.white,
        borderBottomWidth: 0,
    },
    borderBottomColor: Colors.textSecondary,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderWidth: 0,
    borderBottomWidth: 1,
    width: '100%',
    autoCapitalize: 'none',
});

export default function UnderlinedTextInput({
    label,
    onChange,
    value,
    error,
    errorText,
    id,
    maxLength,
    autoComplete,
    disabled,
    boldLabel,
    type,
    alwaysShowLabel,
}: IInputProps) {
    const [touched, setTouched] = useState(false);

    function getPlaceholder() {
        return value || alwaysShowLabel ? '' : label;
    }

    return (
        <Grid container direction="column">
            {label && (
                <Grid item>
                    <label
                        style={{
                            ...styles.label,
                            fontWeight: boldLabel ? 'bold' : 'normal',
                            visibility: value || alwaysShowLabel ? 'visible' : 'hidden',
                        }}
                    >
                        {label}
                    </label>
                </Grid>
            )}
            <Grid item>
                <StyledInput
                    disabled={disabled}
                    id={id}
                    type={type ?? 'text'}
                    value={value}
                    onChange={(e) => onChange(e.target.value, validateEmail(e.target.value))}
                    onBlur={() => setTouched(true)}
                    placeholder={getPlaceholder()}
                    style={{ color: Colors.primary }}
                    maxLength={maxLength ?? undefined}
                    autoComplete={autoComplete}
                />
            </Grid>
            {touched && error ? (
                <Grid container item alignItems="center" style={{ paddingTop: 5 }}>
                    <Grid
                        item
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <CancelIcon style={{ color: Colors.error, fontSize: 14, marginRight: 4 }} />
                        <p style={styles.errorText}>{errorText}</p>
                    </Grid>
                </Grid>
            ) : null}
        </Grid>
    );
}
